import React, { useEffect } from 'react'
import { FieldValues, useForm, UseFormGetValues } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Col, Form } from 'react-bootstrap'
import * as yup from 'yup'
import { useSelector } from 'react-redux'

import { IChild } from '../../store/participant/interfaces'
import { ChildNameField, DateOfBirthField } from './ParticipantFormFields'
import { childSchema } from './ParticipantSchemaDefinitions'
import { Validator } from '../../hooks/validators'
import { checkProperAge, checkWithinMaxAgeWithTolerance } from '../../functions/registrations/ageIntegrity'
import { RootState } from '../../store'

export const ParticipantChildForm = (props: {
  child: IChild
  onCreateForm: (values: UseFormGetValues<FieldValues>, validator: Validator) => void
  onRemoveForm: () => void
}) => {
  const {
    child,
    onCreateForm,
    onRemoveForm,
  } = props
  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations,
  )
  const { age_check_tolerance, family_data_children_max_age: maxAge } = useSelector(
    (state: RootState) => state.program.data,
  )

  const { loadedViaCode } = useSelector(
    (state: RootState) => state.misc,
  )
  const validationSchema = yup.object().shape({
    ...childSchema,
    date_of_birth: childSchema.date_of_birth.test({
      name: 'proper_age_check',
      test: function(value: string) {
        if(!loadedViaCode && maxAge) {
          const maxAgeRes = checkWithinMaxAgeWithTolerance(value, maxAge, age_check_tolerance)
          return maxAgeRes.ok && !maxAgeRes.message
          ? true
          : this.createError({ path: 'date_of_birth', message: maxAgeRes.message })
        }
        return true
      },
    }),
  })
  const { register, formState, formState: { errors }, getValues, trigger } = useForm(
    {
      resolver: yupResolver(validationSchema),
      mode: 'onChange',
    },
  )

  const formFieldProperties = {
    person: child,
    loadedViaCode: loadedViaCode, // Can't be used together with the family mode
    errors,
    formState,
    register,
  }

  useEffect(() => {
    onCreateForm(getValues, { trigger, formName: 'ParticipantChildForm' })
  })

  return (
    <Form className='border rounded p-3'>
      <Form.Row>
        <ChildNameField
          formFieldProperties={formFieldProperties}
          child={child.id}
        />
      </Form.Row>
      <Form.Row>
        <DateOfBirthField
          formFieldProperties={formFieldProperties}
          child={child.id}
        />
      </Form.Row>
      <Form.Row>
        <Col>
          <Form.Group>
            <Button
              variant='danger'
              onClick={onRemoveForm}
              className='mobile-btn mb-0'
            >
              Entfernen
            </Button>
          </Form.Group>
        </Col>
      </Form.Row>
    </Form>
  )
}
